import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCreateFilesKey } from '../../utils/keys';
export const useCreateFiles = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const createFilesKey = getCreateFilesKey();
    return useMutation(input => client.media.uploadFiles(input, useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError), {
        mutationKey: createFilesKey,
        ...useMutationOptions,
        onError: useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError,
    });
};
//# sourceMappingURL=useCreateFiles.js.map